$( document ).ready(function() {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();
    
            document.querySelector(this.getAttribute('href')).scrollIntoView({
                behavior: 'smooth'
            });
        });
    });
    // Collection Tabs
    $('.collection-tabs-section .products-wrapper').slick({
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 580,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: true
          }
        }
      ]
    });

    // HA changes for coll-slider-v2 section
    $('.HA-col-slider-v2-prod-wrapper').slick({
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
      fade: true,
      cssEase: 'linear',
      responsive: 
      [
        {
          breakpoint: 580,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: true
          }
        }
      ]
    });

     $('.recommand-box .recommand-products-wrapper').slick({
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  
// Collection Tabs
    var $status = $('.pagingInfo');
    var $slickElement = $('.special-collections-section .products-wrapper');
  //   var countslick = slick.slideCount;
  // console.log(countslick);
    $slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
      //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
      var i = (currentSlide ? currentSlide : 0) + 1;
      $status.text(i + '/' + slick.slideCount);
    });
    
    $slickElement.slick({
        infinite: false,
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        appendDots: $('.special-dots'),
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
    });

// main-featured-product
    $('.main-featured-product .products-wrapper').slick({
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
    $('.instafeed-new-layout-wrapper').slick({
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
    // Love Note Grid
    $('.love-notes-grid .slider-wrapper').slick({
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 990,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
    // FAQS
    let title = document.querySelectorAll(".faqs-section .faq-box .faqs-wrapper .faq-item .title-block");
    title.forEach((qsitem) => {
        qsitem.addEventListener("click", function (e) {
            let sibling = qsitem.nextElementSibling;
            title.forEach((item) => {
                (item.nextElementSibling.style.height = "0px"), item != qsitem && item.parentNode.classList.remove("active");
            }),
                this.parentNode.classList.toggle("active"),
                qsitem.parentNode.classList.contains("active") ? (sibling.style.height = sibling.scrollHeight + "px") : (sibling.style.height = "0px");
        });
    });
  // Product Accordion
  let title_one = document.querySelectorAll(".product-accordion .accordion-item .title-block");
    title_one.forEach((qsitem) => {
        qsitem.addEventListener("click", function (e) {
            let sibling = qsitem.nextElementSibling;
            title_one.forEach((item) => {
                (item.nextElementSibling.style.height = "0px"), item != qsitem && item.parentNode.classList.remove("active");
            }),
                this.parentNode.classList.toggle("active"),
                qsitem.parentNode.classList.contains("active") ? (sibling.style.height = sibling.scrollHeight + "px") : (sibling.style.height = "0px");
        });
    });
  // Product media
    $('.product__media-wrapper .product-media-wrapper').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
      appendDots: $('.product-main-dots'),
    });
    $('.product-top-info .slider-wrapper').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
      appendDots: $('.product-info-dots'),
    });
    $('.product__description p').each(function() {
        var $p = $(this),
            txt = $p.html();
        if (txt=='&nbsp;') {
            $p.remove();   
        }
    });
});
$(".menu-open").on("click", function() {
  console.log($(this).nextAll());
  $(this).nextAll(".drawer-products").toggleClass("active");
});
$( ".drawer-header .left-block" ).on( "click", function() {
  $('body').removeClass('overflow-hidden-desktop');
});

// $(document).ready(function () {
//   var $status = $('.pagingInfo');
//   var $slickElement = $('.special-collections-section .products-wrapper');
//   let numberOfSlides = [];
//   var slickInitCount = []; 
//   let tabId ;
//   let tabNumber = 1;
  
//   if ($slickElement.hasClass('slick-initialized')) {
//     $slickElement.slick('unslick'); // Destroy previous instance
//   }

//   // $('.special-dots').empty(); // Remove any extra dots

//   $slickElement.on('init reInit afterChange', function (event, slick, currentSlide) {
//     slickInitCount.push(slickInitCount.length + 1); // Store initialization count
//     // console.log(slick)
//     numberOfSlides.push(slick.slideCount)
//     var i = (currentSlide ? currentSlide : 0) + 1;

//     console.log("numberOfSlides", numberOfSlides[tabNumber - 1] ,numberOfSlides, tabNumber)
//     $status.text(i + ' / ' + numberOfSlides[tabNumber - 1]);
//   });

//   $slickElement.slick({
//     infinite: true,
//     slidesToShow: 2,
//     slidesToScroll: 1,
//     arrows: true,
//     dots: true,
//     appendDots: $('.special-dots'),
//     autoplay: false,
//     autoplaySpeed: 2000,
//     responsive: [
//       {
//         breakpoint: 1200,
//         settings: {
//           slidesToShow: 2,
//           slidesToScroll: 1
//         }
//       },
//       {
//         breakpoint: 768,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1
//         }
//       }
//     ]
//   });

//    document.querySelectorAll('.slick-dots').forEach((el, index) => {
//           el.id = `slick-dots-${index + 1}`;
//         });

//   var defaultTab = 1;  // Show the first tab's corresponding dots by default
//     var defaultTabId = 'slick-dots-' + defaultTab;
    
//     const allDots = document.querySelectorAll('.slick-dots');
//     allDots.forEach(dot => {
//         if (dot.id === defaultTabId) {
//             // dot.style.display = 'flex';  // Show the default .slick-dots-1
//           dot.classList.add('active');
//         } else {
//             // dot.style.display = 'none';   // Hide the other .slick-dots-* elements
//           dot.classList.remove('active');
//         }
//     })
// });
// product page ugc video slider
function waitForSwiper(trigger) {
  var interval = setInterval(function () {
    if (typeof Swiper != "undefined") {
      clearInterval(interval);
      trigger();
    }
  }, 50);
  setTimeout(function () {
    clearInterval(interval);
  }, 15000);
}

function addScript() {
  var swiperScript = document.createElement("script");
  swiperScript.src =
    "https://cdnjs.cloudflare.com/ajax/libs/Swiper/4.0.7/js/swiper.min.js";
  document.getElementsByTagName("head")[0].appendChild(swiperScript);
}


  
  if (typeof Swiper == "undefined") {
    addScript();
  }
  
  waitForSwiper(function () {
    var egswiperTiktok = new Swiper(".eg-video-section .swiper-container", {
      // Optional parameters
      direction: "horizontal",
      spaceBetween: 40,
      slidesPerView: 4.2,
      roundLengths: true,
      loop: true,
      arrow: true,
      breakpoints: {
        1800: {
          slidesPerView: 4.4,
        },
        1199:{
          slidesPerView: 4.4,
        },
        991: {
          slidesPerView: 4.4,
        },
        800: {
          slidesPerView: 2.4,
        },
        500: {
          slidesPerView: 1.3,
          spaceBetween: 30,
        },
        320: {
          slidesPerView: 1.2,
          spaceBetween: 20,
        },
      },
      pagination: {
        el: ".eg-video-section-inr .slider__pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".eg-video-section .swiper-button-next",
        prevEl: ".eg-video-section .swiper-button-prev",
      },
    });
});

// HA changes, this is the script that triggers ATC button on the product page for update changes

// document.addEventListener("DOMContentLoaded", function () {
//     function updateButtonPrice() {
//         let button = document.querySelector('.product-form__submit.button span'); // Ensure this matches your theme
//         let priceElement = document.querySelector('.price-item.price-item--sale.price-item--last');

//         if (button && priceElement) {
//             let buttonText = "Add to Cart"; // Ensure this matches your theme's default button text
//             button.innerHTML = `${buttonText} - ${priceElement.innerText.trim()}`;
//         } else {
//             console.log("Price element or button not found.");
//         }
//     }
//     function logUpdatedVariantData() {
//         let productDataElement = document.querySelector('[data-selected-variant]');
//         if (productDataElement) {
//             try {
//                 let productData = JSON.parse(productDataElement.textContent);
//                 console.log("Updated Product Data:", productData);
                
//                 // After logging data, update button price
//                 setTimeout(updateButtonPrice, 100); // Delay to allow Shopify to update DOM
//             } catch (error) {
//                 console.log("Error parsing product data:", error);
//             }
//         } else {
//             console.log("Product data not found.");
//         }
//     }
//     // Listen for variant selection change
//     document.body.addEventListener("change", function (event) {
//         if (event.target.matches('input[type="radio"][name^="Size"], input[type="radio"][name^="Mattress"]')) {
//             console.log("Variant Selected:", event.target.value);

//             // Fetch updated data & update button price
//             setTimeout(logUpdatedVariantData, 300);
//         }
//     });

//     // Watch for Shopify's automatic URL update when a variant changes
//     let lastUrl = window.location.href;
//     new MutationObserver(() => {
//         if (window.location.href !== lastUrl) {
//             lastUrl = window.location.href;
//             console.log("URL Changed: Fetching updated variant data...");
//             setTimeout(logUpdatedVariantData, 300);
//         }
//     }).observe(document.body, { childList: true, subtree: true });
// });


document.addEventListener("DOMContentLoaded", function () {
    function updateButtonPrice() {
        let button = document.querySelector('.product-form__submit.button span'); 
        let priceElement = document.querySelector('.price-item.price-item--sale.price-item--last');

        if (button && priceElement) {
            let translatedButtonText = button.getAttribute("data-translated-text") || button.textContent.split(" - ")[0].trim();  
            button.innerHTML = `${translatedButtonText} - ${priceElement.innerText.trim()}`;
        } else {
            console.log("Price element or button not found.");
        }
    }

    function logUpdatedVariantData() {
        let productDataElement = document.querySelector('[data-selected-variant]');
        if (productDataElement) {
            try {
                let productData = JSON.parse(productDataElement.textContent);
                console.log("Updated Product Data:", productData);

                // After logging data, update button price
                setTimeout(updateButtonPrice, 100);
            } catch (error) {
                console.log("Error parsing product data:", error);
            }
        } else {
            console.log("Product data not found.");
        }
    }

    // Listen for variant selection change
    document.body.addEventListener("change", function (event) {
        if (event.target.matches('input[type="radio"][name^="Size"], input[type="radio"][name^="Mattress"]')) {
            console.log("Variant Selected:", event.target.value);

            // Fetch updated data & update button price
            setTimeout(logUpdatedVariantData, 300);
        }
    });

    // Watch for Shopify's automatic URL update when a variant changes
    let lastUrl = window.location.href;
    new MutationObserver(() => {
        if (window.location.href !== lastUrl) {
            lastUrl = window.location.href;
            console.log("URL Changed: Fetching updated variant data...");
            setTimeout(logUpdatedVariantData, 300);
        }
    }).observe(document.body, { childList: true, subtree: true });
});





